import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { LOCATION_LIST_COLUMN_LABEL_I18N_KEY } from '../location-list/location-list.config';
import { useLocationListContext } from '../location.context';

export const LocationListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useLocationListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={LOCATION_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
